"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zSetTenantThemeRequest = exports.zCreateTenantRequest = exports.SHOP_TYPES = exports.PDF_TEMPLATES = void 0;
const zod_1 = require("zod");
const shop_profile_js_1 = require("./shop-profile.js");
Object.defineProperty(exports, "PDF_TEMPLATES", { enumerable: true, get: function () { return shop_profile_js_1.PDF_TEMPLATES; } });
Object.defineProperty(exports, "SHOP_TYPES", { enumerable: true, get: function () { return shop_profile_js_1.SHOP_TYPES; } });
/**
 * Platform-admin-only: creates a brand-new tenant plus its owner account in
 * one shot. Deliberately minimal — just what an admin actually has in hand
 * when onboarding a new shop by phone/email — everything else (legal name,
 * address, tax settings, invoice wording) is defaulted server-side to the
 * same values every real tenant already converges on; an owner can still
 * change their own via Shop Settings afterward. `ownerFullName`/`ownerEmail`
 * are also exactly the fields a future self-registration form would collect
 * for itself, not just for someone else — this shape is meant to be reused
 * there, not just here.
 */
exports.zCreateTenantRequest = zod_1.z.object({
    shopName: zod_1.z.string().trim().min(1),
    ownerFullName: zod_1.z.string().trim().min(1),
    ownerEmail: zod_1.z.string().trim().toLowerCase().email(),
    // Optional — omitting it leaves the tenants.country column at its own
    // 'US' default. The admin UI pre-fills this from the browser's own
    // locale as a starting guess (see guessCountryFromLocale() in
    // apps/web/src/lib/geo.ts), editable before creating the tenant; it's
    // otherwise only ever changed afterward via Shop Settings.
    country: zod_1.z.enum(shop_profile_js_1.SUPPORTED_COUNTRY_CODES).optional(),
    // Optional — omitting it leaves the tenants.shop_type column at its own
    // 'auto_repair' default. Same "pick it now, change it later" shape as
    // country: also editable afterward via the admin panel's own per-tenant
    // Shop type selector (setTenantTheme), never locked in at creation.
    shopType: zod_1.z.enum(shop_profile_js_1.SHOP_TYPES).optional(),
});
/** At least one field must be present — an empty body is rejected
 * server-side rather than silently no-op'ing. */
exports.zSetTenantThemeRequest = zod_1.z
    .object({
    pdfTemplate: zod_1.z.enum(shop_profile_js_1.PDF_TEMPLATES).optional(),
    shopType: zod_1.z.enum(shop_profile_js_1.SHOP_TYPES).optional(),
})
    .refine((v) => v.pdfTemplate !== undefined || v.shopType !== undefined, {
    message: "At least one of pdfTemplate or shopType must be provided.",
});
//# sourceMappingURL=admin.js.map